<template>
    <b-row>
        <b-col md="12">
            <b-card
                v-if="boardDocument && !loading"
                no-body
            >
                <b-card-body>
                    <div class="d-flex justify-content-between flex-wrap">
                        <h4>
                            [{{ $t('org.common.Notice') }}] {{ boardDocument.subject }}
                        </h4>
                        <b-button
                            size="sm"
                            @click="goToList"
                        >
                            <i class="fa fa-arrow-left"></i>
                        </b-button>
                    </div>
                </b-card-body>
                <b-card-body>
                    <b-card-text class="ql-container">
                        <div class="d-flex justify-content-end">
                            <b-card-text>
                                {{ new Date(parseInt(boardDocument.timestamp, 10)).toLocaleString($i18n.locale) }}
                            </b-card-text>
                        </div>
                        <template v-for="(item, itemIdx) in boardDocument.paragraphs">
                            <div v-if="item.type=='p'" :key="itemIdx">
                                <div v-html="item.content"></div>
                            </div>
                            <div v-if="item.type=='img' && item.src!=''" :key="itemIdx">
                                <img :src="item.src" :style="{'width': item.width + 'px'}">
                            </div>
                        </template>
                        <div
                            v-if="boardDocument.contents"
                            class="ql-editor"
                            v-html="boardDocument.contents"
                        ></div>
                    </b-card-text>
                </b-card-body>
            </b-card>
        </b-col>
    </b-row>
</template>

<script>
import { getCurrentInstance, computed, ref, toRefs, onMounted, watch } from '@vue/composition-api'
// eslint-disable-next-line
import 'quill/dist/quill.core.css'
// eslint-disable-next-line
import 'quill/dist/quill.snow.css'
// eslint-disable-next-line
import 'quill/dist/quill.bubble.css'
export default {
    props: {
        timestamp: {
            type: String,
            default: null
        },
        service: {
            type: String,
            default: 'all'
        }
    },
    setup (props, context) {
        const vm = getCurrentInstance().proxy
        const store = vm.$store
        const { timestamp, service } = toRefs(props)
        const loading = ref(true)
        const boardDocuments = computed(() => store.getters.boardDocuments)
        const boardDocument = computed(() => store.getters.boardDocument)
        const getBoardDocument = (timestamp, service) => store.dispatch('getBoardDocument', { timestamp, service })
        onMounted(() => {
            getBoardDocument(timestamp.value, service.value).then(() => {
                loading.value = false
            })
        })
        const goToList = () => {
            vm.$router.push('/notices')
        }
        watch(timestamp, (value) => {
            getBoardDocument(value, service.value)
        })
        return {
            loading,
            boardDocuments,
            boardDocument,
            getBoardDocument,
            goToList
        }
    }
}
</script>

<style>

</style>
